import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeliveryErrorDomesticForm, DeliveryErrorDomesticFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { filter, tap } from 'rxjs';
import { DeliveryIssueTypeDomestic } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddErrorMessage, RemoveErrorMessage, AddCurrentCodLine } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { ManagerSelectComponent } from '../../../../shared/components/manager-select/manager-select.component';

@Component({
    selector: 'app-cod-delivery-error-domestic-step',
    templateUrl: './delivery-error-domestic.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent,
        ManagerSelectComponent
    ],
    standalone: true
})
export class CodDeliveryErrorDomesticStepComponent implements OnInit {
    @Input() deliverErrorDomesticForm: FormGroup<DeliveryErrorDomesticFormGroup> | undefined;

    private relatedCallTrackingNumberTouched = false;
    public deilveryErrorType = DeliveryIssueTypeDomestic;

    constructor(private store: Store) { }

    ngOnInit(): void {
        this.initFinancialAdjustmentChangesListener();
        this.initCallTagTrackingNumberTouchedListener();
        this.initRelatedDocumentsListener();
    }

    public isDefined(control: keyof DeliveryErrorDomesticForm): boolean {
        return this.deliverErrorDomesticForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof DeliveryErrorDomesticForm): boolean {
        return this.deliverErrorDomesticForm?.controls[control].value === true;
    }

    public isFalse(control: keyof DeliveryErrorDomesticForm): boolean {
        return this.deliverErrorDomesticForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.deliverErrorDomesticForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.deliverErrorDomesticForm?.valid ?? false;
    }

    private initFinancialAdjustmentChangesListener(): void {
        this.deliverErrorDomesticForm?.controls.financialAdjustment.valueChanges
            .pipe(
                filter(value => value === false),
                tap(() => {
                    this.deliverErrorDomesticForm?.controls.adjustmentAmount.setValue(0);
                    this.deliverErrorDomesticForm?.controls.filedWithin30Days.setValue(null);
                    this.deliverErrorDomesticForm?.controls.managerApprovedRequest.setValue(null);
                }))
            .subscribe();
    }

    private initCallTagTrackingNumberTouchedListener(): void {
        this.deliverErrorDomesticForm?.controls.callTagTrackingNumber.valueChanges
            .pipe(
                filter(() => !this.relatedCallTrackingNumberTouched),
                tap(() => {
                    this.store.dispatch(new AddErrorMessage(WorkflowError.UPLOAD_PROOF));

                    this.relatedCallTrackingNumberTouched = true;
                })
            )
            .subscribe();
    }

    private initRelatedDocumentsListener(): void {
        this.deliverErrorDomesticForm?.controls.relatedDocuments.valueChanges
            .pipe(
                filter(value => !!value && value.length > 0),
                tap(() => this.store.dispatch(new RemoveErrorMessage(WorkflowError.UPLOAD_PROOF)))
            )
            .subscribe();
    }
}
